"use client";

import React from "react";
import { Shield, Info } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const privacyFeatures = [{
  title: "Secure Transition of Information",
  description: "When law enforcement officers submit welfare check details through our portal, that publicly available FOIA data is immediately secured within our system. We ensure a seamless, protected handoff from emergency services to our compassionate care network, guaranteeing that sensitive details are only accessible to authorized foundation personnel coordinating aid.",
  icon: Shield
}, {
  title: "Ethical Record-Keeping",
  description: "All submitted information—including names, addresses, and specific needs—is maintained in strict confidence. Our record-keeping practices are designed to protect the dignity of every senior we serve. Data is utilized exclusively to match seniors with appropriate volunteer companions and to facilitate necessary spiritual and basic needs support.",
  icon: Info
}];
export default function OurCommitmentToPrivacy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-commitment-to-privacy" className="bg-background py-20 md:py-32">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Our Commitment to Privacy
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            We understand the sensitive nature of the information provided by law
            enforcement and the public. The St. Sampson Senior Aid Foundation is
            dedicated to handling all senior aid requests with the utmost
            confidentiality, respect, and ethical care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16">
          {privacyFeatures.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="bg-card/50 backdrop-blur-sm border-border/40 shadow-sm hover:shadow-md transition-shadow duration-300 h-full flex flex-col">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center mb-6">
                    <Icon className="w-6 h-6 text-secondary" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-serif text-2xl text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}